window._ = window._3 = require('lodash');
window.jQuery = window.$ = require('jquery');
window.Backbone = require('backbone');
window.bowser = require('bowser');
window.StackTrace = require('stacktrace-js');

const oldIsFunction = window._3.isFunction;
window._3.isFunction = function isFunction(value) {
    return oldIsFunction(value) || Object.prototype.toString.call(value) === '[object AsyncFunction]';
};

